module.exports = __webpack_public_path__ + "static/media/Carga_tus_documentos_V1.abf53fb2.gif";